import { createFileRoute, redirect } from "@tanstack/react-router";
import { SignUpArea } from "~/features/auth/_components/sign-up/sign-up-area.js";

export const Route = createFileRoute("/_not-authed/sign-up")({
  beforeLoad: ({ context }) =>
  {
    if (context.auth?.isAuthenticated === true)
    {
      throw redirect({ to: "/" });
    }
  },
  component: SignUpPage,
});

function SignUpPage()
{
  return (
    <div className="min-h-screen grid place-items-center px-4 py-8 overflow-x-hidden">
      <div className="w-full max-w-md">
        <SignUpArea />
      </div>
    </div>
  );
}
